module.exports = __webpack_public_path__ + "static/media/baby_monitor_finalne_pcb.469848c3.png";